<template>
  <div class="mb-16 font-normal">
    <div class="heading-subfolder-name mb-12 flex items-center justify-start">
      <zt-avatar v-if="flagToShowName && nameSubFolder !=='' && !errors.has('nb-subfolder')" :text="nameSubFolder[0]" size="38px" color="" class="mr-4 flex-none" />
      <zt-avatar v-else text="T" size="38px" color="" class="mr-4 flex-none" />
      <h2 class="font-medium" v-if="flagToShowName && nameSubFolder !=='' && !errors.has('nb-subfolder')"> {{nameSubFolder}} </h2>
      <h2 class="font-medium" v-else>{{ $t('message.abm.folders.settings.subFolderName.default') }}</h2>
    </div>
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.subFolderName.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.subFolderName.description') }}
    </p>
    <div class="w-full custom-input">
      <zt-input
        ref="ztInputName"
        v-model="nameSubFolder"
        class="w-full"
        name="nb-subfolder"
        :color="errorText ? 'danger' : 'primary'"
        v-validate="{ required: true, min: 3, max:150 , regex: /^[a-zA-Z0-9\\s\\:ñÑàèìòùáéíóúäëïöü\- ]*$/ }"
        outlined
        @focusout="flagToShowName = true"
        :label="$t('message.abm.folders.settings.subFolderName.placeholder')"
        data-vs-input="subfolder"
      />
      <span class="text-zt-danger absolute text-base pt-1" v-show="errorText">
        {{ errorText }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SubFolderName',
  inject: ['stateFolder', 'setSubFolderParams', 'resetError'],
  data() {
    return {
      nameSubFolder: '',
      flagToShowName: false,
      showTrashButton: false,
    }
  },
  computed: {
    errorText() {
      if (this.errors.first('nb-subfolder')) {
        return this.errors.first('nb-subfolder')
      }
      return ''
    }
  },
  created() {
    this.isUpdate = this.stateFolder.subFolderParams.isUpdate
    this.nameSubFolder = this.stateFolder.subFolderParams.name
    this.flagToShowName = this.nameSubFolder !== ''
    this.showTrashButton = this.isUpdate && this.stateFolder.subFolderParams.deleteFolder
  },
  watch: {
    errorText() {
      if (this.$refs.ztInputName.$el && this.errorText) {
        this.$refs.ztInputName._data.isFocused = true
      }
    },
    nameSubFolder() {
      if (this.errorText) this.resetError()
      setTimeout(() => {
        if (!this.errors.has('nb-folder')) {
          this.setSubFolderParams({
            name: this.nameSubFolder
          })
        } else {
          this.setSubFolderParams({
            name: ''
          })
        }
      }, 10)
    }
  }
}
</script>
<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-input {
  ::v-deep {
    .zt-label {
      font-size: 1.125rem;
      margin: 0;
    }
    .zt-input {
      font-size: 1.125rem;
    }
  }
}
.heading-subfolder-name {
  h2 {
    font-size: 24px;
    color: #2D2D2D;
  }
  .button-delete {
    border: 0 none;
    background: #FFF;
    font-size: 24px;
    line-height: 24px;
  }
  ::v-deep {
    .zt-avatar span {
      font-size: 24px;
      transform: scale(1) !important;
    }
  }
}
</style>
